import { render, staticRenderFns } from "./UnmuteIcon.vue?vue&type=template&id=24414524&scoped=true&"
import script from "./UnmuteIcon.vue?vue&type=script&lang=js&"
export * from "./UnmuteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24414524",
  null
  
)

export default component.exports